import styles from './TestimonialsSection.module.scss';

import React from 'react';
import Link from 'gatsby-link';
import { Container, Row, Col } from 'reactstrap';
import { ScrollOverPack, TweenOne, FadeUp, FadeIn } from 'src/components/Animations';

export default (props) => (
  <ScrollOverPack {...props}
                  className={props.className}
                  styleName='testimonials-section'>
      <TweenOne key='headers' styleName='headers' component={Container} {...FadeIn}>
          <div className='h2'>
              Galleon serves elite shippers across the country
          </div>
          <div className='h2 text-blue'>
              Here&rsquo;s what they have to say.
          </div>
      </TweenOne>
      <TweenOne key='row' component={Container} {...FadeUp}>
          <Row>
              <Col lg='4' xs='12'>
                  <div styleName='cell-wrapper'>
                      <div styleName='quote'>
                          &ldquo;Galleon <em>brings transparency</em> to a space that's very opaque...love the product.&rdquo;
                      </div>
                      <div styleName='attribution'>
                          <div styleName='name'>
                              Richard Greiner
                          </div>
                          <div>
                              Co-founder
                          </div>
                          <div>
                              <a href='https://www.huckberry.com/' target='_blank'>Huckberry</a>
                          </div>
                      </div>
                  </div>
              </Col>
              <Col lg='4' xs='12'>
                  <div styleName='cell-wrapper'>
                      <div styleName='quote'>
                          &ldquo;Galleon transforms unusable data into <em>refined
                          insight,</em> imperative for shaping the user
                          experience.&rdquo;
                      </div>
                      <div styleName='attribution'>
                          <div styleName='name'>
                              Julia Babina
                          </div>
                          <div>
                              Director of Operations
                          </div>
                          <div>
                              <a href='https://www.brooklinen.com/' target='_blank'>Brooklinen</a>
                          </div>
                      </div>
                  </div>
              </Col>
              <Col lg='4' xs='12'>
                  <div styleName='cell-wrapper'>
                      <div styleName='quote'>
                          &ldquo;The team really took the time to <em>understand
                          my business.</em> They’re responsive, supportive, and
                          smart.&rdquo;
                      </div>
                      <div styleName='attribution'>
                          <div styleName='name'>
                              Charles Zhong
                          </div>
                          <div>
                              Founder
                          </div>
                          <div>
                              <a href='https://www.azazie.com/' target='_blank'>Azazie</a>
                          </div>
                      </div>
                  </div>
              </Col>
          </Row>
      </TweenOne>
  </ScrollOverPack>
);



// WEBPACK FOOTER //
// ./src/components/TestimonialsSection.js